<div class="create-dialog-box">
  <div class="title d-flex align-items-center justify-content-space-between">
    <h4 class="mb-0">Add New Map Object</h4>
    <button class="close-btn bg-transparent p-0 border-none" (click)="close()">
      <i class="flaticon-close"></i>
    </button>
  </div>
  <block-ui>
    <form [formGroup]="fiberForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-lg-12 col-md-12">
          <div class="form-group">
            <label class="d-block fw-semibold">Name</label>
            <input
              type="text"
              class="input-control"
              formControlName="name"
              placeholder="Fiber Name *"
            />
          </div>
        </div>
        <div class="col-lg-12 col-md-12">
          <div class="form-group">
            <label class="d-block fw-semibold">Count</label>
            <input
              type="number"
              class="input-control"
              formControlName="count"
              placeholder="Count"
            />
          </div>
        </div>
        <div class="col-lg-12 col-md-12">
          <div class="form-group">
            <label class="d-block fw-semibold">Type</label>
            <input
              type="text"
              class="input-control"
              formControlName="type"
              placeholder="Type"
            />
          </div>
        </div>
        <div class="col-lg-12 col-md-12">
          <div class="form-group">
            <label class="d-block fw-semibold">Category</label>
            <input
              type="text"
              class="input-control"
              formControlName="category"
              placeholder="Category"
            />
          </div>
        </div>
        <div class="col-lg-12 col-md-12">
          <div class="form-group">
            <label class="d-block fw-semibold">Note</label>
            <textarea
              matInput
              class="input-control"
              formControlName="note"
              placeholder="Any comments eg. location issues, etc."
            ></textarea>
          </div>
        </div>
      </div>
      <div class="text-end">
        <button type="button" class="gray" (click)="close()">
          <i class="ri-close-fill"></i> Cancel
        </button>
        <button type="submit"><i class="ri-add-fill"></i> Save</button>
      </div>
    </form>
  </block-ui>
</div>
